<template>

    <section id="new_ref_fourth_step" class="flex step_ref_4">

        <titlePage>
            <template slot="titleHead">
                <div class="hero-head has-text-centered" >
                    <h1 class="title has-text-weight-light is-size-1 has-text-weight-light">{{ currentRef.name }}</h1>
                    <h2 class="associated_ref_name">{{ $t('modules.refs.formStep4.associatedRef') }} : <span>{{ getRefName(associatedRef) }}</span></h2>
                </div>
            </template>
        </titlePage>

        <div class="hero">
            <div class="title_notice_line">
                <div class="coeffs_heading container">
                    <h1 class="page-title title is-size-2 has-text-weight-bold">{{ $t('modules.refs.formStep4.title') }}</h1>
                    <notifText v-html="$t('modules.refs.formStep4.globalNotice')" />
                </div>
            </div>

            <div class="hero-body">
                <div class=" bottom-section container">
                    <div class="model_align_btn small_margin" @click="syncScores" :class="{active: isAligned}" v-if="!notOwnedRef">
                        <span>{{ $t('modules.refs.formStep4.SyncRefButton') }}</span>
                        <div class="btn_tick">
                            <div class="btn_inner_tick"></div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="scores_columns_container">
                                <div v-for="( scoreKey, index ) in firstScoresMap">
                                    <h3 class="dim_cat_title ref_score_cat_title" v-if="index == 0">
                                        {{ $t('dimensions.skills_titles.title1') }}
                                    </h3>
                                    <h3 class="dim_cat_title ref_score_cat_title" v-if="index == 2">
                                        {{ $t('dimensions.skills_titles.title3') }}
                                    </h3>

                                    <SkillScoreRadios
                                        :score-id="scoreKey"
                                        :score='currentRef.sight3_scores[scoreKey]'
                                        :ref-score="associatedRef.sight3_scores[scoreKey]"
                                        :friendRef1="selectedFriend1"
                                        :friendRef2="selectedFriend2"
                                        :disabled="notOwnedRef"
                                        @change="syncVal" />
                                </div>
                            </div>

                        </div>
                        <div class="column">
                            <div class="scores_columns_container">

                                <div v-for="( scoreKey, index ) in middleScoresMap">
                                    <h3 class="dim_cat_title ref_score_cat_title" v-if="index == 0">
                                        {{ $t('dimensions.skills_titles.title4') }}
                                    </h3>


                                    <SkillScoreRadios
                                        :score-id="scoreKey"
                                        :score='currentRef.sight3_scores[scoreKey]'
                                        :ref-score="associatedRef.sight3_scores[scoreKey]"
                                        :friendRef1="selectedFriend1"
                                        :friendRef2="selectedFriend2"
                                        :disabled="notOwnedRef"
                                        @change="syncVal" />
                                </div>
                            </div>

                        </div>
                        <div class="column">
                            <div class="scores_columns_container">
                                <div v-for="( scoreKey, index ) in lastScoresMap">

                                    <h3 class="dim_cat_title ref_score_cat_title" v-if="index == 0">
                                        {{ $t('dimensions.skills_titles.title2') }}
                                    </h3>


                                    <SkillScoreRadios
                                        :score-id="scoreKey"
                                        :score='currentRef.sight3_scores[scoreKey]'
                                        :ref-score="associatedRef.sight3_scores[scoreKey]"
                                        :friendRef1="selectedFriend1"
                                        :friendRef2="selectedFriend2"
                                        :disabled="notOwnedRef"
                                        @change="syncVal" />
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="has-text-centered" v-if="isNew">
                        <btn-circle-icon  v-bind:class="{disabled: !isFormValid}" class="large" icon="icon-arrow-right" @click.native="nextStep" />
                    </div>

                    <FriendsDropdown v-if="hasFriends"
                        @firstFriendChange="firstFriendChange"
                        @secondFriendChange="secondFriendChange"
                        :sightRefFriends="sightRefFriends" />
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import titlePage from "@/components/layouts/titlePage"
import FriendsDropdown from "./friendsDropdown"

export default {
    name: 'FormStep3',
    props: ['isNew', "notOwnedRef"],
    components: {
        FriendsDropdown,
        titlePage
    },
    data(){
        return {
            firstScoresMap: ["r1", "r2", "r8", "r9"],
            middleScoresMap: ["r10", "r11", "r12", "r13", "r14", "r15", "r16", "r17"],
            lastScoresMap: ["r3", "r4", "r5", "r6", "r7"],
            selectedFriend1: null,
            selectedFriend2: null
        }
    },
    computed: {
        currentRef(){
            return this.$store.state.RefStore.currentRef
        },
        associatedRef(){
            return this.$store.state.RefStore.currentRef.associated_ref
        },
        isAligned(){
            return JSON.stringify(this.currentRef.sight3_scores) ===  JSON.stringify(this.associatedRef.sight3_scores)
        },
        isFormValid(){
            return true
        },
        sightRefFriends(){
            return this._.filter(this.currentRef.sight_ref_friends, function(o) { return o.completed; });
        },
        hasFriends(){
            if (this.sightRefFriends){
                return this.sightRefFriends.length > 0
            }else{
                return false
            }
        }
    },
    mounted(){
        const emptyScores = JSON.stringify({"r1":0,"r2":0,"r3":0,"r4":0,"r5":0,"r6":0,"r7":0,"r8":0,"r9":0,"r10":0,"r11":0,"r12":0,"r13":0,"r14":0,"r15":0,"r16":0,"r17":0})
        if(JSON.stringify(this.currentRef.sight3_scores) === emptyScores){ this.syncScores() }
        this.$store.commit('RefStore/updateFormValidity', { index: 2, validity: this.isFormValid } )
    },
    methods: {
        getRefName(refItem){
            return refItem.job_titles[this.$i18n.locale]
        },
        syncVal(scoreData){
            const objectToSend = {sight3_scores: { } }
            objectToSend.sight3_scores[scoreData.id] = scoreData.val
            this.$store.commit('RefStore/updateRefData', objectToSend )
            this.$store.commit('RefStore/updateFormValidity', { index: 2, validity: this.isFormValid } )

        },
        syncScores(){
            const objectToSend = { sight3_scores: this.associatedRef.sight3_scores }
            this.$store.commit('RefStore/updateRefData', objectToSend )
        },
        nextStep(){
            if(this.isFormValid){
                this.$store.commit('RefStore/changeCurrentStep', { index: 3 })
            }
        },
        firstFriendChange(friendRef){
            this.selectedFriend1 = friendRef
        },
        secondFriendChange(friendRef){
            this.selectedFriend2 = friendRef
        }
    }
  }

</script>

<style lang="scss">
    .title_notice_line{
        background-color: #f5f5f5;
        padding: 12px 0 0;
        h1, .notification_text{
            text-align: center!important;
        }
    }
    .model_align_btn{
            justify-content: center;
            margin-top: 0!important;
    }
    .small_margin{
        margin: 25px 0;
    }
    .step_ref_4{
        background: $white;
    }
    .scores_columns_container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center
    }
</style>
